export default __webpack_public_path__ + "static/media/ic_split_24px.40bbe25b.svg";